import { useCallback, useEffect, useState } from "react";
import api, { getToken } from "@/lib/api";

export const THREADS_CHANGED_EVENT = "brv:threads-changed";

/** Ping all useUnreadThreads consumers to refetch (new push, thread opened, etc.). */
export function notifyThreadsChanged() {
  window.dispatchEvent(new Event(THREADS_CHANGED_EVENT));
}

/**
 * Unread negotiation-thread counts for the current user.
 * Returns { by_bid, by_request, total, refresh }.
 * Refetches on mount and whenever notifyThreadsChanged() fires
 * (notification socket events, thread modal marking a thread read).
 */
export function useUnreadThreads() {
  const [unread, setUnread] = useState({ by_bid: {}, by_request: {}, total: 0 });

  const refresh = useCallback(async () => {
    if (!getToken()) return;
    try {
      const r = await api.get("/threads/unread");
      setUnread(r.data);
    } catch {
      /* badge fetch is best-effort */
    }
  }, []);

  useEffect(() => {
    refresh();
    window.addEventListener(THREADS_CHANGED_EVENT, refresh);
    return () => window.removeEventListener(THREADS_CHANGED_EVENT, refresh);
  }, [refresh]);

  return { ...unread, refresh };
}
